import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { FaTrash } from "react-icons/fa";
import axios from 'axios';
const BE_URI = process.env.REACT_APP_BE_URI;

const DeleteTriggerModal = ({
  modalVisible,
  setModalVisible,
  buttonColor,
  t,
  triggers,
  triggerToDelete,
  urlToSend,
  token,
  handleReadData,
  closeParentModal,
}) => {

  const handleDeleteTrigger = async () => {
    try {

      const newTriggerArray = triggers.filter(
        (trigger) => !(trigger.status === triggerToDelete.status && trigger.time === triggerToDelete.time)
      );

      const formData = {
        url: '' + urlToSend,
        data: 'triggers:' + JSON.stringify(newTriggerArray),
      };

      const res = await axios.post(BE_URI + '/send-data', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        console.log(t('SuccesfullySendData'));
        setModalVisible(false);
        setTimeout(() => {
            handleReadData();
        }, 1200);
      } else {
        console.log('Error: ' + res.data.message);
        closeParentModal();
      }
    } catch (error) {
      console.log('Error: ' + error.message);
      closeParentModal();
    }
  };

  return (
    <Dialog
      open={modalVisible}
      onClose={() => setModalVisible(false)}
      aria-labelledby="delete-trigger-dialog-title"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle
        id="delete-trigger-dialog-title"
        style={{ backgroundColor: buttonColor, color: '#FFFFFF', textAlign: 'center' }}
      >
        {t('DeleteTrigger')}
      </DialogTitle>
      <DialogContent style={{ textAlign: 'center', marginTop: '10%' }}>
        <Typography variant="body1" gutterBottom>
          {t('AreYouSureDeleteTrigger')}
        </Typography>
         <FaTrash  color={buttonColor} style={{ marginTop: '5px' }} /> 
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center', marginTop: 2}}>
        <Button
          variant="contained"
          style={{ backgroundColor: buttonColor, color: '#FFFFFF' }}
          onClick={() => setModalVisible(false)}
        >
          {t('Cancel')}
        </Button>
        <Button
          variant="contained"
          style={{ backgroundColor: buttonColor, color: '#FFFFFF' }}
          onClick={handleDeleteTrigger}
        >
          {t('Delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTriggerModal;
